import {Component, OnDestroy, OnInit} from '@angular/core';
import {InformationService} from "../../services/information.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'privacy-policy',
  templateUrl: './privacy-policy.component.html',
  styleUrls: ['./privacy-policy.component.less']
})
export class PrivacyPolicyComponent implements OnInit, OnDestroy{

  addressLink: SafeHtml;
  shopAddress : SafeHtml;
  privatePolicy: SafeHtml;

  private destroySubject: Subject<void> = new Subject();

  constructor(
    private informationService: InformationService,
  ) {
    this.addressLink = environment.shopAddress.link;
  }

  ngOnInit(): void {
   this.informationService.getFrontParams().pipe(
        takeUntil(this.destroySubject),
      )
        .subscribe(
          (res: any) => {
                let privatePolicyHtml = res.results.find ((value:any) =>  value.name == 'privatePolicy')?.value;
                this.privatePolicy = this.informationService.getSanitizeString(privatePolicyHtml);

                let shopAddressHtml  = res.results.find ((value:any) =>  value.name == 'address')?.value;
                this.shopAddress = this.informationService.getSanitizeString(shopAddressHtml);

          })
  }



  ngOnDestroy() {
    this.destroySubject.next();
  }

}




